module.exports = __webpack_public_path__ + "static/img/810.c081942d.png";